module.exports = __webpack_public_path__ + "static/media/discuss-talent.02587b80.svg";